module.exports = __webpack_public_path__ + "static/media/snapchat_logo_icon.aeb10951.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/snapchat_logo_icon.svg
// module id = 140
// module chunks = 0